import { NgModule } from '@angular/core';
import { FormatBudgetPipe } from '@ui-kit/pipes/format-budget.pipe';
import { FormatDatePipe } from '@ui-kit/pipes/format-date.pipe';
import { FormatDecimalTimePipe } from '@ui-kit/pipes/format-decimal-time.pipe';
import { FormatFilterPipe } from '@ui-kit/pipes/format-filter.pipe';
import { FormatPeriodPipe } from '@ui-kit/pipes/format-period.pipe';
import { FormatStatusPipe } from '@ui-kit/pipes/format-status.pipe';
import { PeriodSelectPipe } from '@ui-kit/pipes/period-select.pipe';
import { SecondsToPeriodPipe } from '@ui-kit/pipes/secondsToPeriod.pipe';
import { DurationPipe } from './duration.pipe';
import { PreviewDateFormatPipe } from './preview-date-format.pipe';
import { ProjectDetailDateFormatPipe } from './project-detail-date-format.pipe';
import { IsPastPipe } from './is-past.pipe';

@NgModule({
  declarations: [
    FormatBudgetPipe,
    FormatDatePipe,
    FormatFilterPipe,
    FormatStatusPipe,
    SecondsToPeriodPipe,
    FormatPeriodPipe,
    PeriodSelectPipe,
    FormatDecimalTimePipe,
    PreviewDateFormatPipe,
    ProjectDetailDateFormatPipe,
    DurationPipe,
    IsPastPipe
  ],
  exports: [
    FormatBudgetPipe,
    FormatDatePipe,
    FormatFilterPipe,
    FormatStatusPipe,
    SecondsToPeriodPipe,
    FormatPeriodPipe,
    PeriodSelectPipe,
    FormatDecimalTimePipe,
    PreviewDateFormatPipe,
    ProjectDetailDateFormatPipe,
    DurationPipe,
    IsPastPipe
  ]
})
export class CommonPipesModule {}
